module.exports = __webpack_public_path__ + "assets/img/8.ada7bf86.png";